import React from 'react';
import {
  Tile,
  IconStatusClose,
  ProgressBar,
  VisuallyHidden,
} from '@seismic/mantle';
import cn from 'classnames';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { Info } from 'react-feather';
import { ERROR_MESSAGES, UPLOAD_STATUS } from './constants';

const FileName = ({ fileName, fileUrl }) => {
  if (fileUrl) {
    return (
      <Text
        className="uploader-tile-information--name"
        href={fileUrl}
        target="_blank"
        rel="noopener noreferrer"
        variant={TEXT_VARIANTS.BODY_LINK}
        component="a"
        data-testid="fileNameLink"
      >
        {fileName}
      </Text>
    );
  }
  return (
    <Text
      className="uploader-tile-information--name"
      variant={TEXT_VARIANTS.MANTLE_BODY_SEMIBOLD}
      component="div"
      data-testid="fileNameDiv"
    >
      {fileName}
    </Text>
  );
};

const File = ({
  fileName = t('universal_uploader.no_file_name'),
  fileSize = '0 MB',
  fileUrl,
  currentProgress = 0,
  uploadStatus,
  handleRemoveFile,
  readOnly,
  error = ERROR_MESSAGES.SERVER_GENERIC,
}) => {
  const shouldDisplayRemoveButton =
    uploadStatus === UPLOAD_STATUS.COMPLETE ||
    uploadStatus === UPLOAD_STATUS.ERROR;

  let srHelperText;
  switch (uploadStatus) {
    case UPLOAD_STATUS.ERROR:
      srHelperText = t('universal_uploader.file_error');
      break;
    case UPLOAD_STATUS.COMPLETE:
      srHelperText = t('universal_uploader.file_uploaded');
      break;
    default:
      srHelperText = t('universal_uploader.file_uploading');
      break;
  }

  return (
    <div className="uploader-file">
      <Tile className="uploader-tile" data-testid="fileTile">
        <VisuallyHidden aria-live="assertive">{srHelperText}</VisuallyHidden>
        <div className="uploader-tile--block">
          <div className="uploader-tile-information">
            <FileName fileName={fileName} fileUrl={fileUrl} />
            <Text
              className="uploader-tile-information--size"
              variant={TEXT_VARIANTS.MANTLE_BODY}
              component="div"
            >
              {fileSize}
            </Text>
          </div>
          {shouldDisplayRemoveButton && (
            <div className="uploader-tile--remove">
              <button
                aria-label={t('universal_uploader.remove_icon_aria')}
                type="button"
                onClick={handleRemoveFile}
                className={cn('u-resetBtn', {
                  'u-resetBtn--disabled': readOnly,
                })}
                disabled={readOnly}
                data-testid="removeFile"
              >
                <IconStatusClose size="16" />
              </button>
            </div>
          )}
        </div>
        {uploadStatus !== UPLOAD_STATUS.ERROR && (
          <ProgressBar value={currentProgress} data-testid="progressBar" />
        )}
      </Tile>
      {uploadStatus === UPLOAD_STATUS.ERROR && (
        <div className="uploader-tile--error">
          <Info size={17} />
          <Text
            variant={TEXT_VARIANTS.INSTRUX_ERROR}
            data-testid="errorMessage"
            aria-live="assertive"
          >
            {error}
          </Text>
        </div>
      )}
    </div>
  );
};

export { File };
